var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"transition--fade"}},[(_vm.layer)?_c('div',{staticClass:"layer"}):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }